/* LACALUT — subtle scroll reveal for IMAGES only. Text is never moved.
   Images fade + ease in as they scroll into view. Images sharing a row (e.g. the 4 product
   cards) cascade left→right with a fixed step; stacked images cascade naturally as you scroll.
   No external deps. Fails safe: if JS never runs, nothing is hidden (class is JS-added only). */
(function () {
  var mq = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');
  if (mq && mq.matches) return;                        // respect reduced-motion
  if (!('IntersectionObserver' in window)) return;      // no polyfill; just show everything

  var STEP = 550;   // ms between each image within the same row — the "sequence" feel
  var CAP = 6;      // keep the delay bounded on very wide rows
  var ROW_TOL = 40; // px: images whose tops are within this are treated as one row

  var SKIP = /jdgm|icon|logo|badge|payment|star|swatch|flag|avatar|sprite/i;

  function isMeaningful(img) {
    if (SKIP.test(img.className || '')) return false;
    if (img.closest && img.closest('.jdgm-widget, .jdgm-carousel, header, footer, .lacfn__attrib')) return false;
    var w = parseInt(img.getAttribute('width') || '0', 10);
    if (w && w < 100) return false;                     // declared-small = icon
    return true;
  }

  function init() {
    var main = document.getElementById('MainContent');
    if (!main) return;
    var sections = Array.prototype.slice.call(main.querySelectorAll(':scope > .shopify-section'));
    var scope = sections.slice(2);                       // leave announcement bar + hero static
    if (!scope.length) return;

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var i = parseInt(e.target.getAttribute('data-reveal-i') || '0', 10);
        e.target.style.transitionDelay = (Math.min(i, CAP) * STEP) + 'ms';
        e.target.classList.add('lac-reveal-img--in');
        io.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -6% 0px', threshold: 0.12 });

    scope.forEach(function (sec) {
      var secImgs = [];
      Array.prototype.forEach.call(sec.querySelectorAll('img'), function (img) {
        if (isMeaningful(img)) secImgs.push(img);
      });
      if (!secImgs.length) return;

      // Sort top→bottom, then left→right, and index each image by its position within its row.
      secImgs.sort(function (a, b) {
        var ra = a.getBoundingClientRect(), rb = b.getBoundingClientRect();
        return (ra.top - rb.top) || (ra.left - rb.left);
      });

      var rowTop = null, idx = 0;
      secImgs.forEach(function (img) {
        var t = img.getBoundingClientRect().top;
        if (rowTop === null || Math.abs(t - rowTop) > ROW_TOL) { rowTop = t; idx = 0; }
        else { idx++; }
        img.setAttribute('data-reveal-i', idx);
        img.classList.add('lac-reveal-img');
        io.observe(img);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
